import React from "react";
import Text from "./component/text";

function App() {
  return (
    <div className="App">
      <header className="App-header">helloword</header>
      <Text />
    </div>
  );
}

export default App;
